import { render, staticRenderFns } from "./DiseaseValueList.vue?vue&type=template&id=57da4ad6&scoped=true"
import script from "./DiseaseValueList.vue?vue&type=script&lang=js"
export * from "./DiseaseValueList.vue?vue&type=script&lang=js"
import style0 from "./DiseaseValueList.vue?vue&type=style&index=0&id=57da4ad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57da4ad6",
  null
  
)

export default component.exports